import { BaseModel } from "sjs-base-model";
import ResponseModel from "./ResponseModel";
import ControlloModel from "stores/simulazione/models/ControlloModel";

export default class PracticeModel extends BaseModel {
    public readonly idPractice: number = 0;
    public readonly errors?: ControlloModel[] = [];
    public readonly warnings?: ControlloModel[] = [];

    constructor(data: Partial<PracticeModel>) {
        super();

        this.update(data);
    }
}
